import { ReactNode } from 'react';
import { motion, type HTMLMotionProps } from 'framer-motion';
import clsx from 'clsx';

interface AnimatedSectionProps extends HTMLMotionProps<'section'> {
  children: ReactNode;
  delay?: number;
}

export const AnimatedSection = ({
  children,
  className,
  delay = 0,
  ...rest
}: AnimatedSectionProps) => (
  <motion.section
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    viewport={{ once: true, amount: 0.3 }}
    className={clsx('w-full', className)}
    {...rest}
  >
    {children}
  </motion.section>
);
